export default __webpack_public_path__ + "assets/fonts/a61e77fd354e216dd532ee5e8d41f622.woff";